module.exports = {
  propsString: { type: String, default: '' },
  propsBoolean: { type: Boolean, default: null },
  propsNumber: { type: Number, default: null },
  propsArray: { type: Array, default: () => [] },
  propsObject: { type: Object, default: () => ({}) },
  propsFunction: { type: Function, default: () => { } },
}
